import flagsSettings from '../../settings/flags'
import userService from './user.service.cookies'

const appFeatureFlags = {
  getCookie(name) {
    let value = '; ' + document.cookie
    let parts = value.split('; ' + name + '=')
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift()
  },
  isEnabled(flag) {
    const cookie = this.getCookie('flags')
    if (cookie) {
      return JSON.parse(decodeURIComponent(cookie))[flag] || false
    }
    return false
  },
  isEnabledForStoryblok(flag) {
    return flagsSettings.staging[flag] || false
  },
  getFlags() {
    const flags = this.getCookie('flags')
    if (flags) {
      return JSON.parse(decodeURIComponent(flags))
    }
    const isStoryblok = window.location.href.includes('_storyblok')
    if (isStoryblok) {
      return flagsSettings.staging
    }
    return {}
  },
  setFlag(flag, value) {
    if (flag === 'analyticsAsInternalUser') {
      return userService.setAnalyticsAsInternalUser(value)
    }

    const flags = this.getCookie('flags')
    const object = JSON.parse(decodeURIComponent(flags))
    if (object) {
      object[flag] = value
    }
    const result = encodeURIComponent(JSON.stringify(object))
    document.cookie =
      'flags=' + result + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/'
  },
  setDefaultFlags() {
    const flags = this.getFlags()
    const envSettings = flagsSettings[process.env.TARGET_ENV]
    if (flags.version !== envSettings.version) {
      const result = encodeURIComponent(JSON.stringify(envSettings))
      document.cookie =
        'flags=' + result + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/'
    }
  },
}

export default appFeatureFlags
